import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HarvestAndPlantingMap from '../HarvestAndPlantingMap';

function HarvestMap(props) {
  return <HarvestAndPlantingMap {...props} />;
}

HarvestMap.propTypes = {
  crop: PropTypes.string.isRequired,
  dates: PropTypes.object.isRequired,
};

function mapStateToProps(state, props) {
  const activeSeason = state.seasons.activeSeasons[props.index];
  const { harvestEndDate, harvestStartDate, harvestYear, cropCustomName } =
    state.seasons.list[activeSeason.id];
  const dates = {
    endDate: harvestEndDate,
    startDate: harvestStartDate,
    year: harvestYear,
  };

  return {
    crop: cropCustomName,
    dates,
  };
}

export default connect(mapStateToProps)(HarvestMap);
